/**
 * Created due to annoyance over array.prototype.map()
 *	forcing [unknown, ...unknown[]] to unknown[]
 */
export function non_empty_map(array, map) {
    return array.map(map);
}
export function non_empty_keys(object) {
    return Object.keys(object);
}
export function require_non_empty_array(maybe) {
    if (maybe.length < 1) {
        throw new Error('Array is empty!');
    }
    return maybe;
}
// because typescript doesn't do this automatically
export function object_keys(object) {
    return Object.keys(object);
}
//# sourceMappingURL=ArrayUtilities.js.map